export default __webpack_public_path__ + "static/media/Nesha_Laser_0003_Particle_4.e4acffcb.png";